module.exports = __webpack_public_path__ + "img/muscle_man_preview.2a72708e.png";